import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import "./firm-reporting-intake.css";
import { api_without_cancellation } from "../../../api/api";
import incidentIcon from "../../../assets/images/incident.svg";
import birthdayIcon from "../../../assets/images/birthdayicon.svg";
import { calculateAge, formatCalendarDate } from "../../../Utils/helper";
import UserChatBubble from "../../Forms/FirmUserBtn";
import TableLoader from "../../Loaders/tableLoader";

const FirmReportingIntake = ({ mainRef, controlRef, template, setReportData }) => {
  const tableRef = useRef(null);
  const [data, setData] = useState([]);
  const userOnlineStatus = useSelector((state) => state.chat2.userOnlineStatus);

  const [availableRows, setAvailableRows] = useState(0);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!mainRef?.current || !controlRef?.current) return;

    const totalHeight = mainRef.current.getBoundingClientRect().height;
    const controlHeight = controlRef.current.getBoundingClientRect().height;
    const availableheight = totalHeight - controlHeight;
    const height = availableheight - 55;

    const rowsFromHeight = Math.floor(height / 25);
    const rowsToSubtract = data?.data?.length ?? 0;

    setAvailableRows(Math.max(0, rowsFromHeight - rowsToSubtract));
  }, [mainRef, controlRef, data]);

  const fetchTemplates = async () => {
    try {
      setLoading(true);
      const res = await api_without_cancellation.get(
        `/api/firm-reporting/firm-reporting-template-cases/?template_id=${template?.id}`
      );

      const data = await res.data;
      setData(data);
      setReportData(data?.data);
    } catch (error) {
      console.error("Error fetching templates:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (template) {
      fetchTemplates();
    } else {
      setData([]);
      setReportData([]);
    }
  }, [template]);

  return (
    <>
      <div
        style={{
          overflowX: "auto",
          overflowY: "hidden",
          width: "100%",
          scrollbarWidth: "none",
        }}
        className="m-b-5 table--no-card invisible-scrollbar rounded-0 border-0 w-100 firm-reporting-table-container"
        ref={tableRef}
      >
        <table
          style={{
            overflowX: "scroll",
          }}
          className="table table-borderless settlement-table"
        >
          <thead>
            <tr
              id="report-tb-header"
              className="settle-t-4 height-25 cursor-default"
              style={{
                background: "var(--primary-10)",
                color: "var(--primary)",
              }}
            >
              <th
                className=""
                style={{
                  width: "35px",
                  minWidth: "35px",
                  maxWidth: "35px",
                  color: "var(--primary-25)",
                }}
              />

              {/* Dynamic columns based on selected report values */}
              {template?.client_first_name && (
                <>
                  <th
                    className="text-start td-autosize"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "25px",
                    }}
                  >
                    First Name
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.client_last_name && (
                <>
                  <th
                    className="text-start td-autosize"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "25px",
                    }}
                  >
                    Last Name
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.client_birthday && (
                <>
                  <th
                    className="text-center td-autosize"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "25px",
                    }}
                  >
                    Birthday
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.client_age && (
                <>
                  <th
                    className="text-center td-autosize"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "25px",
                    }}
                  >
                    Age
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.case_type_category && (
                <>
                  <th
                    className="text-center td-autosize"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "25px",
                    }}
                  >
                    Case Type Category
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.case_type && (
                <>
                  <th
                    className="text-center td-autosize"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "25px",
                    }}
                  >
                    Case Type
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.incident_date && (
                <>
                  <th
                    className="text-center td-autosize"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "25px",
                    }}
                  >
                    Incident Date
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.intake_date && (
                <>
                  <th
                    className="text-center td-autosize"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "25px",
                    }}
                  >
                    Intake
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.retained_date && (
                <>
                  <th
                    className="text-center td-autosize"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "25px",
                    }}
                  >
                    Retained
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.acceptance_date && (
                <>
                  <th
                    className="text-center td-autosize"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "25px",
                    }}
                  >
                    Acceptance
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.closed_date && (
                <>
                  <th
                    className="text-center td-autosize"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "25px",
                    }}
                  >
                    Closed
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.referred_date && (
                <>
                  <th
                    className="text-center td-autosize"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "25px",
                    }}
                  >
                    Referred
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.rejected_date && (
                <>
                  <th
                    className="text-center td-autosize"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "25px",
                    }}
                  >
                    Rejected
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.source_type && (
                <>
                  <th
                    className="text-center td-autosize"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "25px",
                    }}
                  >
                    Source Type
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.source_name && (
                <>
                  <th
                    className="text-center td-autosize"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "25px",
                    }}
                  >
                    Source Name
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.secondary_source_type && (
                <>
                  <th
                    className="text-center td-autosize"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "25px",
                    }}
                  >
                    Secondary Source Type
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.secondary_source_name && (
                <>
                  <th
                    className="text-center td-autosize"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "25px",
                    }}
                  >
                    Secondary Source Name
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.third_source_type && (
                <>
                  <th
                    className="text-center td-autosize"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "25px",
                    }}
                  >
                    Third Source Type
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.third_source_name && (
                <>
                  <th
                    className="text-center td-autosize"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "25px",
                    }}
                  >
                    Third Source Name
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.firm_user_intake && (
                <>
                  <th
                    className="text-center td-autosize"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "25px",
                    }}
                  >
                    Firm User (Intake)
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.firm_user_retained && (
                <>
                  <th
                    className="text-center td-autosize"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "25px",
                    }}
                  >
                    Firm User (Retained)
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.firm_user_accepted && (
                <>
                  <th
                    className="text-center td-autosize"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "25px",
                    }}
                  >
                    Firm User (Accepted)
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.firm_user_rejected && (
                <>
                  <th
                    className="text-center td-autosize"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "25px",
                    }}
                  >
                    Firm User (Rejected)
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.firm_user_referred && (
                <>
                  <th
                    className="text-center td-autosize"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "25px",
                    }}
                  >
                    Firm User (Referred)
                  </th>
                </>
              )}

              <th
                className=""
                style={{
                  width: "15px",
                  minWidth: "15px",
                  maxWidth: "15px",
                }}
              />
            </tr>
          </thead>
          <tbody id="body-table mb-1" className="table-firm-reporting">
            {loading && <TableLoader />}
            {!loading &&
              data?.data?.map((reporting, idx) => {
                return (
                  <>
                    <tr key={reporting?.id} className="cursor-default height-25">
                      <td
                        className="text-center"
                        style={{ width: "35px", color: "var(--primary-25)" }}
                      >
                        {idx + 1}
                      </td>
                      {/*  */}
                      {template?.client_first_name && (
                        <>
                          <td className="text-start">{reporting?.for_client?.first_name}</td>
                          <td className="" />
                        </>
                      )}

                      {template?.client_last_name && (
                        <>
                          <td className="text-start">{reporting?.for_client?.last_name}</td>
                          <td className="" />
                        </>
                      )}

                      {template?.client_birthday && (
                        <>
                          <td className="text-start">
                            <div
                              style={{
                                gap: "5px",
                                color: "black",
                                fontWeight: "bold",
                              }}
                              className="d-flex align-items-center"
                            >
                              <span className="ic-avatar ic-15 d-flex">
                                <img src={birthdayIcon} />
                              </span>
                              <span>{formatCalendarDate(reporting?.for_client?.birthday)}</span>
                            </div>
                          </td>
                          <td className="" />
                        </>
                      )}

                      {template?.client_age && (
                        <>
                          <td className="text-start">
                            <div
                              style={{
                                gap: "5px",
                                color: "black",
                                fontWeight: "bold",
                              }}
                              className="d-flex align-items-center"
                            >
                              <span className="text-primary-50 me-0">Age</span>
                              <span className="ms-0">
                                {calculateAge(reporting?.for_client?.birthday)}
                              </span>
                            </div>
                          </td>
                          <td className="" />
                        </>
                      )}

                      {template?.case_type_category && (
                        <>
                          <td className="text-start">
                            <div
                              style={{
                                //   gap: "5px",
                                color: "black",
                                fontWeight: "bold",
                              }}
                              className="d-flex align-items-center"
                            >
                              {/*  */}
                            </div>
                          </td>
                          <td className="" />
                        </>
                      )}

                      {template?.case_type && (
                        <>
                          <td className="text-start">
                            <div
                              style={{
                                gap: "5px",
                                color: "black",
                                fontWeight: "bold",
                              }}
                              className="d-flex align-items-center"
                            >
                              {reporting?.case_type?.casetype_icon && (
                                <span className="ic-avatar ic-15 d-flex">
                                  <img src={reporting?.case_type?.casetype_icon} />
                                </span>
                              )}
                              <span>{reporting?.case_type?.name}</span>
                            </div>
                          </td>
                          <td className="" />
                        </>
                      )}

                      {template?.incident_date && (
                        <>
                          <td className="text-start">
                            <div
                              style={{
                                gap: "5px",
                                color: "black",
                                fontWeight: "bold",
                              }}
                              className="d-flex align-items-center"
                            >
                              <span className="ic-avatar ic-15 d-flex">
                                <img src={incidentIcon} />
                              </span>
                              <span>{formatCalendarDate(reporting?.incident_date)}</span>
                            </div>
                          </td>
                          <td className="" />
                        </>
                      )}

                      {template?.intake_date && (
                        <>
                          <td className="text-end">{formatCalendarDate(reporting?.intake_date)}</td>
                          <td className="" />
                        </>
                      )}

                      {template?.retained_date && (
                        <>
                          <td className="text-end">{formatCalendarDate(reporting?.retained)}</td>
                          <td className="" />
                        </>
                      )}

                      {template?.acceptance_date && (
                        <>
                          <td className="text-end">
                            {formatCalendarDate(reporting?.accepted_date)}
                          </td>
                          <td className="" />
                        </>
                      )}

                      {template?.closed_date && (
                        <>
                          <td className="text-end">{formatCalendarDate(reporting?.date_closed)}</td>
                          <td className="" />
                        </>
                      )}

                      {template?.referred_date && (
                        <>
                          <td className="text-end">
                            {formatCalendarDate(reporting?.case_referred)}
                          </td>
                          <td className="" />
                        </>
                      )}

                      {template?.rejected_date && (
                        <>
                          <td className="text-end">
                            {formatCalendarDate(reporting?.case_rejected)}
                          </td>
                          <td className="" />
                        </>
                      )}

                      {template?.source_type && (
                        <>
                          <td className="text-end">{/*  */}</td>
                          <td className="" />
                        </>
                      )}

                      {template?.source_name && (
                        <>
                          <td className="text-end">{/*  */}</td>
                          <td className="" />
                        </>
                      )}

                      {template?.secondary_source_type && (
                        <>
                          <td className="text-end">{/*  */}</td>
                          <td className="" />
                        </>
                      )}

                      {template?.secondary_source_name && (
                        <>
                          <td className="text-end">{/*  */}</td>
                          <td className="" />
                        </>
                      )}

                      {template?.third_source_type && (
                        <>
                          <td className="text-end">{/*  */}</td>
                          <td className="" />
                        </>
                      )}

                      {template?.third_source_name && (
                        <>
                          <td className="text-end">{/*  */}</td>
                          <td className="" />
                        </>
                      )}

                      {template?.firm_user_intake && (
                        <>
                          <td className="text-end">
                            {/*  */}
                            <UserChatBubble
                              userId={reporting?.intake_date_user?.id}
                              first_name={reporting?.intake_date_user?.first_name ?? ""}
                              last_name={reporting?.intake_date_user?.last_name ?? ""}
                              profilePic={reporting?.intake_date_user?.profile_pic ?? ""}
                              is_active={reporting?.intake_date_user?.is_active}
                              width={21}
                              isActive={
                                userOnlineStatus?.[reporting?.intake_date_user?.id]?.isOnline ??
                                false
                              }
                            />
                          </td>
                          <td className="" />
                        </>
                      )}

                      {template?.firm_user_retained && (
                        <>
                          <td className="text-end">
                            {/*  */}
                            <UserChatBubble
                              userId={reporting?.retained_date_user?.id}
                              first_name={reporting?.retained_date_user?.first_name ?? ""}
                              last_name={reporting?.retained_date_user?.last_name ?? ""}
                              profilePic={reporting?.retained_date_user?.profile_pic ?? ""}
                              is_active={reporting?.retained_date_user?.is_active}
                              width={21}
                              isActive={
                                userOnlineStatus?.[reporting?.retained_date_user?.id]?.isOnline ??
                                false
                              }
                            />
                          </td>
                          <td className="" />
                        </>
                      )}

                      {template?.firm_user_accepted && (
                        <>
                          <td className="text-end">
                            {/*  */}
                            <UserChatBubble
                              userId={reporting?.accepted_date_user?.id}
                              first_name={reporting?.accepted_date_user?.first_name ?? ""}
                              last_name={reporting?.accepted_date_user?.last_name ?? ""}
                              profilePic={reporting?.accepted_date_user?.profile_pic ?? ""}
                              is_active={reporting?.accepted_date_user?.is_active}
                              width={21}
                              isActive={
                                userOnlineStatus?.[reporting?.accepted_date_user?.id]?.isOnline ??
                                false
                              }
                            />
                          </td>
                          <td className="" />
                        </>
                      )}

                      {template?.firm_user_rejected && (
                        <>
                          <td className="text-end">
                            {/*  */}
                            <UserChatBubble
                              userId={reporting?.case_rejected_user?.id}
                              first_name={reporting?.case_rejected_user?.first_name ?? ""}
                              last_name={reporting?.case_rejected_user?.last_name ?? ""}
                              profilePic={reporting?.case_rejected_user?.profile_pic ?? ""}
                              is_active={reporting?.case_rejected_user?.is_active}
                              width={21}
                              isActive={
                                userOnlineStatus?.[reporting?.case_rejected_user?.id]?.isOnline ??
                                false
                              }
                            />
                          </td>
                          <td className="" />
                        </>
                      )}

                      {template?.firm_user_referred && (
                        <>
                          <td className="text-end">
                            {/*  */}
                            <UserChatBubble
                              userId={reporting?.case_referred_user?.id}
                              first_name={reporting?.case_referred_user?.first_name ?? ""}
                              last_name={reporting?.case_referred_user?.last_name ?? ""}
                              profilePic={reporting?.case_referred_user?.profile_pic ?? ""}
                              is_active={reporting?.case_referred_user?.is_active}
                              width={21}
                              isActive={
                                userOnlineStatus?.[reporting?.case_referred_user?.id]?.isOnline ??
                                false
                              }
                            />
                          </td>
                        </>
                      )}

                      <td />
                    </tr>
                  </>
                );
              })}
            {Array.from({ length: Math.max(0, availableRows || 0) }).map((_, index) => (
              <tr key={`fake-row-${index}`} style={{ height: "25px" }}>
                <td colSpan={51}>&nbsp;</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default FirmReportingIntake;
